import { render, staticRenderFns } from "./GeneralDataForm.vue?vue&type=template&id=7806ec22"
import script from "./GeneralDataForm.vue?vue&type=script&lang=js"
export * from "./GeneralDataForm.vue?vue&type=script&lang=js"
import style0 from "./GeneralDataForm.vue?vue&type=style&index=0&id=7806ec22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
